import { MutationTree } from "vuex";
import { IdomReactionStateInterface } from "./state";
import { IIdomReactionItem } from "src/modules/idom-reaction/models/IdomReactions";

const mutation: MutationTree<IdomReactionStateInterface> = {
  setReactions(state, payload: IIdomReactionItem[]) {
    state.reactions = payload;
  },
  incrementMessage(state, guid: string) {
    const index = state.reactions.findIndex(
      (reaction) => reaction.original_message_guid === guid,
    );
    state.reactions[index].current_answers_count++;
    return (
      state.reactions[index].current_answers_count >=
      state.reactions[index].max_answers_count
    );
  },
  setTotal(state, total: number) {
    state.totalReactions = total;
  },
};

export default mutation;
